import { render } from "./MemberPanel.vue?vue&type=template&id=0afbcb3e"
import script from "./MemberPanel.vue?vue&type=script&lang=js"
export * from "./MemberPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__